import { useEffect } from "react";
import { hideLegacyPreloader } from "./hideLegacyPreloader";

const vendorScripts = [
  "/js/jquery-3.5.1.min.js",
  "/js/jquery-migrate-3.0.0.min.js",
  "/js/modernizr-2.6.2.min.js",
  "/js/imagesloaded.pkgd.min.js",
  "/js/jquery.isotope.v3.0.2.js",
  "/js/pace.js",
  "/js/popper.min.js",
  "/js/bootstrap.min.js",
  "/js/scrollIt.min.js",
  "/js/jquery.waypoints.min.js",
  "/js/owl.carousel.min.js",
  "/js/jquery.stellar.min.js",
  "/js/jquery.magnific-popup.js",
  "/js/YouTubePopUp.js",
  "/js/before-after.js",
];

function loadScript(src, { bust = false } = {}) {
  return new Promise((resolve, reject) => {
    const el = document.createElement("script");
    el.src = bust ? `${src}?v=${Date.now()}` : src;
    el.async = false;
    el.onload = () => resolve(true);
    el.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.body.appendChild(el);
  });
}

function ensureVendorScriptsLoaded() {
  // Avoid duplicate vendor loads across SPA navigations.
  const existing = new Set(
    Array.from(document.querySelectorAll("script[data-legacy-src]"))
      .map((s) => s.getAttribute("data-legacy-src"))
      .filter(Boolean)
  );

  return vendorScripts.reduce((p, src) => {
    if (existing.has(src)) return p;

    return p.then(async () => {
      const el = document.createElement("script");
      el.src = src;
      el.async = false;
      el.setAttribute("data-legacy-src", src);
      document.body.appendChild(el);

      await new Promise((resolve, reject) => {
        el.onload = () => resolve(true);
        el.onerror = () => reject(new Error(`Failed to load ${src}`));
      });
    });
  }, Promise.resolve());
}

export default function useLegacyServicesScripts(enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    let cancelled = false;
    const fallback = window.setTimeout(hideLegacyPreloader, 2000);
    (async () => {
      try {
        await ensureVendorScriptsLoaded();
        if (cancelled) return;

        // Always re-run the page initializers (custom.js) so animate-box
        // and progress/background logic binds to the newly inserted DOM.
        await loadScript("/js/custom.js", { bust: true });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("[legacy-services-scripts] init issue:", e);
      } finally {
        window.clearTimeout(fallback);
        if (!cancelled) hideLegacyPreloader();
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [enabled]);
}

